import {jsx as $hgUW1$jsx, jsxs as $hgUW1$jsxs} from "react/jsx-runtime";
import {useState as $hgUW1$useState, forwardRef as $hgUW1$forwardRef} from "react";
import {Root as $hgUW1$Root} from "@radix-ui/react-aspect-ratio";
import {createStitches as $hgUW1$createStitches} from "@stitches/react";
import {document as $hgUW1$document} from "browser-monads-ts";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $e4acaba73a0bf664$exports = {};

$parcel$export($e4acaba73a0bf664$exports, "YouTubeLite", () => $e4acaba73a0bf664$export$c9d7f92e282245c6);





function $38f78f9653b8c1ef$export$d6012f328bf1cd22(props) {
    return(/*#__PURE__*/ $hgUW1$jsxs("svg", {
        viewBox: "0 0 68 48",
        width: "1em",
        height: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ $hgUW1$jsx("path", {
                d: "M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ $hgUW1$jsx("path", {
                d: "M45 24 27 14v20",
                fill: "#fff"
            })
        ]
    }));
}



let { styled: $9c0c1da424ccdc87$export$3817b7a54a07cec7  } = $hgUW1$createStitches();


const $ecc1c06c828ca7b8$export$26b41f0a3f763d03 = $9c0c1da424ccdc87$export$3817b7a54a07cec7($hgUW1$Root, {
    backgroundColor: '#000',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    contain: 'content',
    cursor: 'pointer',
    '&::before': {
        content: '""',
        backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==)',
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'top',
        boxSizing: 'border-box',
        display: 'block',
        height: 60,
        paddingBottom: 50,
        position: 'absolute',
        top: 0,
        transition: 'all 0.2s cubic-bezier(0, 0, 0.2, 1)',
        width: '100%'
    },
    '& iframe': {
        border: 0,
        height: '100%',
        width: '100%'
    }
});
const $ecc1c06c828ca7b8$export$a4adf5e49d50b390 = $9c0c1da424ccdc87$export$3817b7a54a07cec7($38f78f9653b8c1ef$export$d6012f328bf1cd22, {
    boxSizing: 'border-box',
    color: '#212121',
    height: 'auto',
    left: '50%',
    opacity: 0.8,
    position: 'absolute',
    top: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    transition: 'all 0.2s cubic-bezier(0, 0, 0.2, 1)',
    width: 68,
    zIndex: 1,
    [`${$ecc1c06c828ca7b8$export$26b41f0a3f763d03}:hover &`]: {
        color: '#f00',
        opacity: 1
    }
});
const $ecc1c06c828ca7b8$export$d99176fc999c3da2 = $9c0c1da424ccdc87$export$3817b7a54a07cec7('iframe', {
});



function $fa5752db109612db$export$c11e62fdf1cb07d0(rel, href, as) {
    let linkEl = $hgUW1$document.createElement('link');
    linkEl.setAttribute('rel', rel);
    linkEl.setAttribute('href', href);
    if (as) linkEl.setAttribute('as', as);
    $hgUW1$document.head.appendChild(linkEl);
}


function $9b70643304db0f84$export$c3d5cd1470cbb2a0({ url: url , videoId: videoId , isPlaylist: isPlaylist , opts: opts  }) {
    let options = {
        ...!isPlaylist ? {
            autoplay: 1
        } : {
            list: videoId
        },
        ...opts
    };
    // @ts-ignore: we can use numbers on the values
    let params = new URLSearchParams(options);
    return `${url}?${params.toString()}`;
}


function $ab6c909dbd3d6a68$export$44cee01bde6a1304(url) {
    const arr = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== arr[2] ? arr[2].split(/[^\w-]/i)[0] : arr[0];
}


function $e4acaba73a0bf664$var$RenderYouTubeLite({ url: url , adNetwork: adNetwork , aspectRatio: aspectRatio = 16 / 9 , css: css , customThumbnail: customThumbnail , iframeProps: iframeProps , noCookie: noCookie = true , playerParameters: playerParameters , playlist: playlist , poster: poster = 'hqdefault' , title: title , ...props }, ref) {
    let [preconnected, setPreconnected] = $hgUW1$useState(false);
    let [iframe, setIframe] = $hgUW1$useState(false);
    let videoId = encodeURIComponent($ab6c909dbd3d6a68$export$44cee01bde6a1304(url));
    let posterUrl = typeof customThumbnail === 'string' ? customThumbnail : `https://i.ytimg.com/vi/${videoId}/${poster}.jpg`;
    let youtubeUrl = noCookie ? 'https://www.youtube-nocookie.com' : 'https://www.youtube.com';
    let iframeSrc = !playlist ? `${youtubeUrl}/embed/${videoId}` : `${youtubeUrl}/embed/videoseries`;
    const warmConnections = ()=>{
        if (preconnected) return;
        // The iframe document and the majority of its subresources are all taken directly from youtube.com.
        $fa5752db109612db$export$c11e62fdf1cb07d0('preconnect', 'https://www.youtube-nocookie.com');
        // The botguard script can be found on google.com.
        $fa5752db109612db$export$c11e62fdf1cb07d0('preconnect', 'https://www.google.com');
        // These ad-related domains may or may not be on the critical path. Domain-specific throttling could be used to confirm.
        if (adNetwork) {
            $fa5752db109612db$export$c11e62fdf1cb07d0('preconnect', 'https://googleads.g.doubleclick.net');
            $fa5752db109612db$export$c11e62fdf1cb07d0('preconnect', 'https://static.doubleclick.net');
        }
        setPreconnected(true);
    };
    const addIframe = ()=>{
        if (iframe) return;
        setIframe(true);
    };
    return(/*#__PURE__*/ $hgUW1$jsx($ecc1c06c828ca7b8$export$26b41f0a3f763d03, {
        css: {
            backgroundImage: `url(${posterUrl})`,
            ...css
        },
        onPointerOver: warmConnections,
        onClick: addIframe,
        "data-title": title,
        ref: ref,
        ratio: aspectRatio,
        ...props,
        children: iframe ? /*#__PURE__*/ $hgUW1$jsx($ecc1c06c828ca7b8$export$d99176fc999c3da2, {
            width: 560,
            height: 315,
            title: title,
            src: $9b70643304db0f84$export$c3d5cd1470cbb2a0({
                url: iframeSrc,
                videoId: videoId,
                isPlaylist: playlist
            }),
            allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            ...iframeProps
        }) : /*#__PURE__*/ $hgUW1$jsx($ecc1c06c828ca7b8$export$a4adf5e49d50b390, {
        })
    }));
}
const $e4acaba73a0bf664$export$c9d7f92e282245c6 = /*#__PURE__*/ $hgUW1$forwardRef($e4acaba73a0bf664$var$RenderYouTubeLite);




export {$e4acaba73a0bf664$export$c9d7f92e282245c6 as YouTubeLite};
//# sourceMappingURL=react-youtube-lite.mjs.map
